import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ServiceProvider } from '../../providers/ServiceProvider';
import { SettingProvider } from '../../providers/SettingProvider';

/*
  Generated class for the Notefication page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-Notefication',
    templateUrl: 'Notefication.html'
})
export class NoteficationPage {

    Notefications: any = [];
    constructor(public navCtrl: NavController, public navParams: NavParams, public serviceProvider: ServiceProvider, public settingProvider: SettingProvider) { }

    ionViewWillEnter() {
        let ids = this.settingProvider.GetIds();
        this.Notefications.splice(0, this.Notefications.length);
        this.serviceProvider.Get("ISPA_Notif/" + ids, true).then((result) => {
            let notefication: any = result;
            notefication.forEach((value, index) => {
                this.Notefications.push(value);
            });
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/Notefication/Notefication.ts